import * as React from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";

import MPHome from "./MainPageComps/MPHome";
import MPStatistic from "./MainPageComps/MPStatistic";
import MPSetting from "./MainPageComps/MPSetting";

export default function MainPage() {
  const [value, setValue] = React.useState(0);

  const renderContent = () => {
    switch (value) {
      case 0:
        return <MPHome />;
      case 1:
        return <MPStatistic />;
      case 2:
        return <MPSetting />;
      default:
        return null;
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh", // full page height
        backgroundColor: "red",
      }}
    >
      <div style={{ textAlign: "center", paddingTop: 20 }}>
        <h1>MainPage</h1>
      </div>
      <div style={{ flex: 1 }}>{renderContent()}</div>

      <Box sx={{ width: "100%" }}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction label="Home" icon={<HomeOutlinedIcon />} />
          <BottomNavigationAction
            label="Statistic"
            icon={<BarChartOutlinedIcon />}
          />
          <BottomNavigationAction
            label="Setting"
            icon={<SettingsSuggestOutlinedIcon />}
          />
        </BottomNavigation>
      </Box>
    </div>
  );
}
